import { readEditionPreferences } from './generated/preferences';
export const scenes = [
  'card',
  'stars',
  'genres',
  'artist',
  'quote',
  'divergence',
  'discovery',
  'seasons',
  'words',
  'festival',
  'persona',
  'quiz',
  'duet',
];
export const sceneTitles = [
  ['음악 명함', 'Music card'],
  ['만점', 'Perfect scores'],
  ['장르', 'Genres'],
  ['아티스트', 'Artist'],
  ['내 리뷰', 'My review'],
  ['다른 별점', 'My perspective'],
  ['재발견', 'Rediscovery'],
  ['흐름', 'Flow'],
  ['단어', 'Words'],
  ['페스티벌', 'Festival'],
  ['취향 유형', 'Taste portrait'],
  ['만점 퀴즈', 'Rating quiz'],
  ['취향 교집합', 'Shared taste'],
];
export function defaults(en) {
  return {
    version: 1,
    period: 'all',
    theme: 'paper',
    format: 'story',
    template: 'editorial',
    intro: en
      ? 'More time to talk about the music I love.'
      : '좋아하는 음악을 오래 이야기하고 싶어요.',
    cardHeading: en ? 'Meet me through music.' : '음악으로 나를 소개합니다.',
    selectedIds: null,
    quoteId: null,
    quoteStart: 0,
    quoteLength: 0,
    showName: true,
    showStats: true,
    showCovers: true,
    artistIntroId: null,
    friendInput: '',
    friendNickname: '',
  };
}
export const customization = (p) =>
  Object.fromEntries(
    [
      'intro',
      'cardHeading',
      'selectedIds',
      'quoteId',
      'quoteStart',
      'quoteLength',
      'showName',
      'showStats',
      'artistIntroId',
      'friendInput',
      'friendNickname',
    ].map((k) => [k, p[k]]),
  );
export const selectionReset = { selectedIds: null, quoteId: null, quoteStart: 0, quoteLength: 0 };
export const selectionChanged = (p, saved) =>
  Object.keys(selectionReset).some((k) => JSON.stringify(p[k]) !== JSON.stringify(saved[k]));
export const settingsKey = (origin, id) =>
  `postpop.web.music-edition.v1.${encodeURIComponent(origin)}.${encodeURIComponent(id)}`;
export function restoreSettings(raw, en) {
  const p = readEditionPreferences(raw);
  return p
    ? {
        ...defaults(en),
        ...p,
        cardHeading: p.cardHeading ?? defaults(en).cardHeading,
        showCovers: true,
        headliner: null,
        selectedWords: undefined,
      }
    : defaults(en);
}
export function editionPayload(response) {
  const data = response?.data?.data ?? response?.data;
  if (
    !Array.isArray(data) ||
    !data.every(
      (r) =>
        r &&
        Number.isSafeInteger(r.album?.id) &&
        r.album.id > 0 &&
        typeof r.album.title === 'string' &&
        (r.album.genres == null ||
          (Array.isArray(r.album.genres) && r.album.genres.every((g) => typeof g === 'string'))) &&
        Number.isSafeInteger(r.review?.id) &&
        r.review.id > 0 &&
        Number.isFinite(r.review.rating) &&
        r.review.rating >= 0 &&
        r.review.rating <= 5 &&
        typeof r.review.content === 'string' &&
        typeof r.review.createdAt === 'string' &&
        typeof r.review.updatedAt === 'string' &&
        (!r.artist || typeof r.artist.name === 'string'),
    )
  )
    throw Error('Invalid edition records');
  return data;
}
export function filterGroups(copy) {
  return [
    {
      id: 'period',
      label: copy('기간', 'Period'),
      options: [
        ['all', copy('전체', 'All time')],
        ['year', copy('올해', 'This year')],
        ['month', copy('이번 달', 'This month')],
      ],
    },
    {
      id: 'scene',
      label: copy('스타일', 'Style'),
      options: scenes.map((s, i) => [s, copy(...sceneTitles[i])]),
    },
    {
      id: 'template',
      label: copy('프레임', 'Frame'),
      options: [
        ['editorial', copy('기본형', 'Editorial')],
        ['poster', copy('포스터', 'Poster')],
      ],
    },
    {
      id: 'theme',
      label: copy('배경', 'Background'),
      options: [
        ['paper', copy('페이퍼', 'Paper')],
        ['night', copy('나이트', 'Night')],
        ['orange', copy('오렌지', 'Orange')],
        ['artwork', copy('커버 블러', 'Cover blur')],
      ],
    },
    { id: 'customize', label: copy('꾸미기', 'Customize'), options: [] },
    {
      id: 'format',
      label: copy('형식', 'Format'),
      options: [
        ['story', copy('스토리', 'Story')],
        ['card', copy('소장 카드', 'Pocket card')],
      ],
    },
  ];
}
// Filter reset must never reset customization (text, albums, friend, excerpt).
export function filterValues(value) {
  return Object.fromEntries(
    filterGroups((ko) => ko)
      .filter((g) => g.options.length && g.options.some(([id]) => id === value[g.id]))
      .map((g) => [g.id, value[g.id]]),
  );
}
